import { render, staticRenderFns } from "./session-item-persons.vue?vue&type=template&id=f0005a78"
import script from "./session-item-persons.vue?vue&type=script&lang=ts"
export * from "./session-item-persons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports